import { NextPageContext } from 'next'
import { useEffect, useRef, useState } from 'react'
import Slider from 'react-slick'
import Button from '../../../../components/_legacy/Button'
import Col from '../../../../components/basic/Col'
import BasicHead from '../../../../components/common/BasicHead'
import Br from '../../../../components/common/Br'
import CenterContainer from '../../../../components/common/CenterContainer'
import DeviceSplit from '../../../../components/common/DeviceSplit'
import VWContainer from '../../../../components/common/VWContainer'
import SliderNextBtn from '../../../../components/common/icons/SliderNextBtn'
import SliderPrevBtn from '../../../../components/common/icons/SliderPrevBtn'
import TailwindWrapper from '../../../../components/container/TailwindWrapper'
import InputWithLabel from '../../../../components/landing-legacy/InputWithLabel'
import MainTitle from '../../../../components/landing-legacy/MainTitle'
import LandingNav from '../../../../components/landing/navigation/LandingNav'
import MobileLandingNav from '../../../../components/landing/navigation/LandingNav/MobileLandingNav'
import Footer from '../../../../components/landing/section/footer'
import { IInitialUserData, ISeoData } from '../../../../model/Common/common.interface'
import apis from '../../../../modules/apis'
import { axiosPost } from '../../../../modules/axiosHelper'
import useIsTablet from '../../../../modules/hooks/common/useIsTablet'
import { LOCALE_KO } from '../../../../modules/i18n/config'
import { s_b2b, s_head } from '../../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../../modules/i18n/useTranslation'
import {
  IMG_K_VOUCHER_CASE_1,
  IMG_K_VOUCHER_CASE_2,
  IMG_K_VOUCHER_CASE_3,
  IMG_K_VOUCHER_MAIN_MOBILE,
  IMG_K_VOUCHER_MAIN_WEB,
  IMG_RINGLE_X_VOUCHER,
} from '../../../../modules/images'
import { getOgUrl, t } from '../../../../modules/utils'
import { COLORS } from '../../../../modules/vars'

const VoucherInfo = () => {
  return (
    <VWContainer>
      <CenterContainer className="py-96 text-center">
        <div className="flex flex-col justify-between sm:flex-row sm:items-end">
          <div className="text-center sm:!text-left">
            <div className="text-d6 sm:text-d4 font-bold">수출 바우처란?</div>
            <div className="text-h4 mt-[16px] text-gray-700">
              중소/중견기업이 자사에 맞는 수출 지원 서비스를 이용할 수 있도록
              <Br md up />
              보조금을 바우처 형태로 지원하는 사업입니다.
            </div>
          </div>
          <div style={{ height: 48 }} className="mt-[32px] flex items-center justify-center sm:mt-0">
            <img src={IMG_RINGLE_X_VOUCHER} className="h-full" alt="image-ringle-x-voucher" />
          </div>
        </div>
      </CenterContainer>
    </VWContainer>
  )
}
const ApplyCorp = () => {
  const [isTablet, setIsTablet] = useIsTablet()
  const howToUse = [
    <>수출지원바우처 웹사이트(www.exportvoucher.com)에서 참여기업 신청</>,
    <>신청기업 평가, 선정 및 수출바우처 운영기관 협약 체결</>,
    <>기업분담금 납부 및 바우처 발급</>,
    <>수출바우처 웹사이트 ‘메뉴판’ ‘역량강화 교육’ 부문에서 링글 검색 후 상품 구매</>,
  ]
  return (
    <VWContainer bgColor="bg-gray-50">
      <CenterContainer className="py-96 text-center">
        <div>
          <div className="w-full text-center">
            <div>
              <div className="text-d6 sm:text-d4 font-bold text-black">
                수출바우처로 링글 수업권 구매시 최대 70% 할인
              </div>
            </div>
            <div className="mt-[64px] text-left font-bold text-gray-700">수출바우처 이용방법</div>
            <div className="mt-[4px] flex flex-col justify-between sm:flex-row">
              {howToUse.map((item, i) => {
                return (
                  <div key={i} className="mt-[12px]">
                    <div className="text-left">
                      <div className="text-h5 text-gray-700">Step {i + 1}</div>
                      <div
                        style={
                          isTablet
                            ? {
                                width: '100%',
                                height: 96,
                                borderColor: COLORS.GRAY300,
                              }
                            : {
                                width: 235,
                                height: 120,
                                borderColor: COLORS.GRAY300,
                              }
                        }
                        className="mt-[4px] rounded-[10px] border border-solid bg-white p-[24px] text-gray-700"
                      >
                        {item}
                      </div>
                    </div>
                  </div>
                )
              })}
            </div>
            <div className="mt-[64px] w-full">
              <a rel="noreferrer" href="https://www.exportvoucher.com/portal/bizinfo/voucher_01" target="_blank">
                <Button lg py10 clx="w-full py-18 whitespace-nowrap" outlined>
                  수출바우처 사업 알아보기
                </Button>
              </a>
            </div>
          </div>
        </div>
      </CenterContainer>
    </VWContainer>
  )
}
const Tip = () => {
  const [isTablet, setIsTablet] = useIsTablet()
  const qna = [
    {
      question: <>결제한 수업권을 직원들과 함께 사용할 수 있나요?</>,
      answer: (
        <>
          수출바우처 플랫폼에서 판매하는 패키지는 최대 3개의 계정에 수업권을 분할 제공할 수 있고, “건별 협의” 상품을
          선택할 경우 교육 인원에 맞게 견적 및 서비스 제공 가능합니다.
        </>
      ),
    },
    {
      question: '수업권을 결제한 시점부터 바로 수강기간이 시작되나요?',
      answer: (
        <>
          <b>수업권을 결제한 시점에 바로 수강기간이 시작되지 않습니다.</b>
          &nbsp;결제한 수업권의 수강 시작일은 학습자가 직접 지정할 수 있습니다. 수업권을 결제하고 첫 수업을 시작한 날
          이후로 수강기간이 시작됩니다. 단, 구매 후 1년이 지나면 수강기간이 자동 차감되기 시작합니다.
        </>
      ),
    },
    {
      question: '결제 이후 학습은 어떻게 진행할 수 있나요?',
      answer: (
        <>
          <b>
            수출바우처 플랫폼에서 결제를 완료하시면, 담당자 개별 연락을 통해 회원가입 및 수업권 제공 절차까지 상세히
            안내해드립니다.
          </b>
          &nbsp;전체 이용 절차: [구매하기] &gt; [서비스상담(유선)] &gt; [결제]
        </>
      ),
    },
    {
      question: '수출바우처로 구매할 수 있는 다른 상품은 어떻게 확인하나요?',
      answer: '수출바우처 플랫폼 검색창에 `링글`을 검색하시면 다른 상품 구성을 확인할 수 있습니다.',
    },
  ]
  return (
    <VWContainer>
      <CenterContainer className="py-96 text-center">
        <div>
          <div className="text-d3 font-bold text-black">수출바우처로 링글 이용하는 Tip</div>
          <div style={isTablet ? { width: '100%' } : { width: 662 }} className="mx-auto mt-[64px]">
            {qna.map((item, i) => {
              return (
                <div key={i} className="mb-[16px] p-[32px] shadow">
                  <div className="text-left">
                    <div className="flex">
                      <span className="font-bold text-purple-500">Q</span>
                      <div className="ml-[4px]">
                        <b>{item.question}</b>
                      </div>
                    </div>
                    <div className="mt-[4px] flex">
                      <span className="font-bold text-purple-500">A</span>
                      <div className="ml-[4px] w-full">
                        <div style={{ lineHeight: 1.5 }}>{item.answer}</div>
                      </div>
                    </div>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </CenterContainer>
    </VWContainer>
  )
}

const Contact = () => {
  const [agree, setAgree] = useState(false)
  const { t } = useTranslation()
  const nameRef = useRef(null)
  const emailRef = useRef(null)
  const phoneRef = useRef(null)
  const askRef = useRef(null)

  const handleSubmit = async (e) => {
    e.preventDefault()
    const name = nameRef.current?.value
    const email = emailRef.current?.value
    const phone = phoneRef.current?.value
    const content = askRef.current?.value

    if (!name || !email || !content || !phone) {
      alert(t(s_b2b.please_fill_in_blank))
      return
    }

    const response = await axiosPost(apis.landing.partner(), {
      name: name,
      email: email,
      phone: phone,
      content: content,
    })
    if (response.success) {
      window.location.reload()
    }
  }

  return (
    <VWContainer bgColor="bg-gray-50">
      <CenterContainer className="py-96 text-center">
        <div className="text-d6 sm:text-d4 font-bold">문의를 남겨주세요</div>
        <div className="mt-[16px] text-gray-700">
          링글 이용 방법과 수출바우처를 통한 구매 방법을 링글 팀에서 친절하게 알려드릴게요
        </div>
        <div className="mt-[64px]">
          <div className="row flex items-center">
            <Col mt16 clx="sm:mt-0">
              <InputWithLabel ref={nameRef} label="이름" placeholder="이름을 입력해주세요" />
            </Col>
            <Col mt16 clx="sm:mt-0">
              <InputWithLabel ref={emailRef} label="이메일" placeholder="이메일을 입력해주세요" />
            </Col>
            <Col mt16 clx="sm:mt-0">
              <InputWithLabel ref={phoneRef} label="전화번호" placeholder="전화번호를 입력해주세요" />
            </Col>
          </div>
          <div className="row mt-[16px] flex items-center">
            <Col>
              <InputWithLabel
                ref={askRef}
                label="문의내용"
                textarea
                placeholder="수출바우처 관련 문의사항을 남겨주세요"
              />
            </Col>
          </div>
          <div className="mt-[24px] text-left text-gray-700">
            <div>
              - 수집 항목 : 성명, 이메일 주소, 전화번호 <br />
              - 수집 목적 : 이메일 및 유선을 통한 링글 수출바우처 수강권 구매 지원 <br />
              - 수집 방법 : 링글 수출바우처 웹사이트 내 신청 양식을 통한 수집 <br />- 개인정보 보유 및 이용기간 : 상담
              종료 후 즉시 파기
            </div>
            <div className="mt-[24px]">
              <input type="checkbox" id="agree" name="agree" onChange={(e) => setAgree(e.target.checked)} />
              <label className="ml-16" htmlFor="agree">
                [필수] 개인정보 수집 및 이용에 동의합니다.
              </label>
            </div>
          </div>
          <div className="mt-[32px] text-left">
            {agree ? (
              <Button outlined lg onClick={handleSubmit}>
                제출하기
              </Button>
            ) : (
              <Button disabled lg>
                제출하기
              </Button>
            )}
          </div>
        </div>
      </CenterContainer>
    </VWContainer>
  )
}

const BestPractices = ({ initialSlide = 0 }: { initialSlide?: number }) => {
  const data = [
    {
      url: IMG_K_VOUCHER_CASE_1,
      title: '글로벌 비즈니스 실무를 담당하고 있다면?',
      subtitle:
        '최신 글로벌 비즈니스 케이스 교재로 원어민 튜터와 토론해보세요. 원어민과 두려움없이 의사소통할 수 있게 됩니다.',
    },
    {
      url: IMG_K_VOUCHER_CASE_2,
      title: '영어 프레젠테이션을 앞두고 있다면?',
      subtitle:
        '직접 준비한 프레젠테이션 자료를 교정받고 연습해보세요. 반복되는 영어 실수를 바로잡고, 발표 상황과 문맥에 맞는 표현을 사용할 수 있습니다.',
    },
    {
      url: IMG_K_VOUCHER_CASE_3,
      title: '해외 비즈니스 파트너와 의사소통해야 한다면?',
      subtitle:
        '컨퍼런스 콜, 화상 미팅, 영어 인터뷰 등 실전 상황을 링글 수업으로 준비하세요. 다양한 비즈니스 상황에서도 영어로 논리 정연하게 의견을 전달할 수 있습니다.',
    },
  ]
  return (
    <VWContainer>
      <CenterContainer className="py-96 text-center">
        <div className="text-d6 sm:text-d4 font-bold">링글 수업, 이렇게 활용해보세요</div>
        <div className="mt-[16px] text-gray-700">개인의 학습 목적에 맞는 맞춤형 수업 진행이 가능합니다</div>
        <div className="row mt-[64px] items-center">
          <Col static>
            <div className="shadow-lg">
              <Slider
                initialSlide={initialSlide}
                dots={false}
                slidesToShow={1}
                slidesToScroll={1}
                infinite={true}
                draggable={false}
                lazyLoad={'ondemand'}
                nextArrow={<SliderNextBtn />}
                prevArrow={<SliderPrevBtn />}
                className="triple-slider pt-0"
              >
                {data.map((item, i) => (
                  <div key={i}>
                    <div key={i} className="grid grid-cols-1 md:grid-cols-2">
                      <div className="mb-8 w-full md:mb-0">
                        <img src={item.url} alt="image" />
                      </div>
                      <div className="p-[64px] text-left">
                        <div className="text-h4 font-bold text-purple-500">Case {i + 1}</div>
                        <div className="text-h3 mt-[16px] font-bold">{item.title}</div>
                        <div className="text-h5 mt-[20px] text-gray-700">{item.subtitle}</div>
                      </div>
                    </div>
                  </div>
                ))}
              </Slider>
            </div>
          </Col>
        </div>
      </CenterContainer>
    </VWContainer>
  )
}

const VoucherFooter = () => {
  const [isTablet, setIsTablet] = useIsTablet()
  return (
    <VWContainer bgColor="bg-black">
      <CenterContainer className="py-64">
        <div className="flex flex-col sm:flex-row sm:justify-between">
          <div>
            <div className="text-d6 sm:text-d3 font-bold text-white">
              영어는 화상으로,
              <br /> 화상영어는 역시 링글
            </div>
            <div className="mt-[16px] font-medium text-white">1:1 화상영어는 링글과 함께하세요.</div>
          </div>
          <div className="mt-[64px] sm:mt-0">
            <div className="text-d6 sm:text-d3 font-bold text-white">수출바우처 관련 문의</div>
            <div className="mt-[16px] text-white">
              <div className="font-medium">전화번호 02-6204-8881 / 010-7397-3431</div>
              <div className="font-medium">이메일 business@ringleplus.com</div>
            </div>
          </div>
        </div>
      </CenterContainer>
    </VWContainer>
  )
}

const Voucher = ({ ogData, seoData }: IInitialUserData) => {
  useEffect(() => {
    setIsMobile(window.innerWidth < 576)
  }, [])

  const { t, locale } = useTranslation()

  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    // Set Scroll To Top
    window.scrollTo(0, 0)
  }, [])

  // FIXME - 임시제거
  // const [showMobileAppDownPopup, onCloseMobileAppDownPopup] = useMobileAppDownPopup()

  return (
    <div>
      <BasicHead ogData={ogData} />

      <DeviceSplit isMobile={isMobile} mobile={<MobileLandingNav />} desktop={<LandingNav />} />

      <TailwindWrapper>
        <MainTitle
          bgImg={isMobile ? IMG_K_VOUCHER_MAIN_MOBILE : IMG_K_VOUCHER_MAIN_WEB}
          darkNormal
          title={
            <>
              <div className="mb-[8px] text-left text-white">링글, 수출바우처 수행기관 선정</div>
              <h1 className="text-d5 sm:text-d1 text-left font-bold text-white">
                수출에 필요한 영어 역량 <Br md up />
                링글 1:1 화상영어로 키워보세요!
              </h1>
            </>
          }
        />
        <VoucherInfo />
        <ApplyCorp />
        <Tip />
        <BestPractices />
        <VoucherFooter />
      </TailwindWrapper>

      <Footer />
    </div>
  )
}

Voucher.getInitialProps = async (context: NextPageContext) => {
  const { lang = LOCALE_KO } = context.query

  const ogData = {
    title: t(s_head.student.title, lang),
    desc: t(s_head.student.desc, lang),
    ogUrl: getOgUrl({ lang, context }),
  }

  const seoData: ISeoData = {
    pageTitle: lang === LOCALE_KO ? '링글 일대일 화상영어 | 수출바우처' : ogData.title,
    pageDescription: null,
    pageKeywords: null,
  }

  return {
    ogData,
    seoData,
  }
}

export default Voucher
